import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AuthService } from './auth.service';

export type PaymentProvider = 'FEDAPAY' | 'ORANGE_MONEY' | 'MTN_MONEY' | 'WAVE' | 'MOOV' | 'VISA_CARD';
export type MethodePaiement = 'ESPECES' | 'VIREMENT' | 'MOBILE_MONEY' | 'CARTE_BANCAIRE' | 'CHEQUE';
export type PaymentType =
  | 'RESERVATION'
  | 'CHECK_IN'
  | 'CHECK_OUT'
  | 'GUARANTEE'
  | 'PROLONGEMENT'
  | 'REMBOURSEMENT_CLIENT'
  | 'REMBOURSEMENT_CREDIT_NUITE'
  | 'COMMISSION_APPORTEUR_AFFAIRE';
export type StatutPaiement = 'EN_ATTENTE' | 'EFFECTUE' | 'ECHOUE' | 'ANNULE' | 'PARTIELLEMENT_PAYEE';

export interface InitiatePaymentRequest {
  montant: number;
  methode: MethodePaiement;
  typePayement: PaymentType;
  provider: PaymentProvider;
  reservationId?: number;
  factureId?: number;
  checkInId?: number;
  returnUrl?: string;
}

export interface InitiatePaymentResponse {
  transactionId: number;
  checkoutUrl: string;
  externalTransactionId: string;
  statut: string;
  montant: number;
  currency: string;
}

export interface TransactionStatus {
  transactionId: number;
  externalTransactionId: string;
  provider: PaymentProvider;
  statut: string;
  paiementStatut: StatutPaiement;
  montant: number;
  currency: string;
  checkoutUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  static readonly TRANSACTION_KEY = 'serenity_transaction_id';

  private readonly apiUrl = environment.apiUrl;
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private get headers(): HttpHeaders {
    const token = this.authService.getToken();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    });
  }

  initiatePayment(payload: InitiatePaymentRequest): Observable<InitiatePaymentResponse> {
    return this.http.post<InitiatePaymentResponse>(
      `${this.apiUrl}/payments/online/initiate`,
      payload,
      { headers: this.headers }
    );
  }

  checkStatus(transactionId: number): Observable<TransactionStatus> {
    return this.http.get<TransactionStatus>(
      `${this.apiUrl}/payments/online/status/${transactionId}`,
      { headers: this.headers }
    );
  }
}
